import { settingsActionTypes } from '@constants/actionTypes/ssapActionTypes';
import { ENABLED, DISABLED } from '@constants/ssap/miscellaneous/miscellaneous';

export const INITIAL_STATE = {
    allowQhpForMedicareEnrollees: ENABLED,
    alwaysDisplayMedicaidQuestions: false,
    autoReenrollSopaConsent: DISABLED,
    collectAdditionalResidencyDetails: DISABLED,
    collectMemberRemovalReason: DISABLED,
    dacaEffective: null,
    displayItuQuestions: ENABLED,
    enableAddressConfidentiality: DISABLED,
    escUiUpdated: DISABLED,
    flipLogicForLivesWithParent: DISABLED,
    itfFeature: DISABLED,
    inlineCurrentIncomeEnabled: DISABLED,
    inlineEligibilityIgnoredForEscPage: DISABLED,
    collectLivingArrangement: DISABLED,
    medicaidEndDateOverride: 90,
    endDateOfPregnancyOverride: 60,
    medicaidTerminationFeature: DISABLED,
    militaryActiveDutyReturnQuestion: DISABLED,
    militaryFamilyMemberQuestion: DISABLED,
    noSsnReasonCollection: DISABLED,
    realtimeCheck: DISABLED,
    showFullTimeStudent: ENABLED,
    showStateEmployeeHealthBenefitPlan: ENABLED,
    sogiFeature: DISABLED,
    voterRegistrationFeature: DISABLED
};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case settingsActionTypes.INITIALIZE_SSAP:
            return action.payload.settings
                ? { ...state, ...action.payload.settings }
                : state;
        case settingsActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

// Selectors

export const selectDacaEffective = state => state.dacaEffective;
export const selectIfMilitaryActiveDutyReturnQuestionEnabled = state => state.militaryActiveDutyReturnQuestion === ENABLED;
export const selectIfMilitaryFamilyMemberQuestionEnabled = state => state.militaryFamilyMemberQuestion === ENABLED;
export const selectIfAlwaysDisplayMedicaidQuestionsEnabled = state => state.alwaysDisplayMedicaidQuestions;
export const selectIfAutoReenrollSopaConsentEnabled = state => state.autoReenrollSopaConsent === ENABLED;
export const selectIfEnableAddressConfidentiality = state => state.enableAddressConfidentiality === ENABLED;
export const selectIfEscUIEnabled = state => state.escUiUpdated === ENABLED;
export const selectIfFlipLogicForLivesWithParentEnabled = state => state.flipLogicForLivesWithParent === ENABLED;
export const selectIfInlineEligibilityIgnoredForEscPage = state => state.inlineEligibilityIgnoredForEscPage === ENABLED;
export const selectIfAdditionalResidencyEnabled = state => state.collectAdditionalResidencyDetails === ENABLED;
export const selectIfLivingArrangement = state => state.collectLivingArrangement === ENABLED;
export const selectIfMedicaidTerminationFeatureEnabled = state => state.medicaidTerminationFeature === ENABLED;
export const selectIfNoSsnReasonCollectionEnabled = state => state.noSsnReasonCollection === ENABLED;
export const selectIfQhpAllowedForMedicare = state => state.allowQhpForMedicareEnrollees === ENABLED;
export const selectIfRealtimeCheckEnabled = state => state.realtimeCheck === ENABLED;
export const selectIfShowFullTimeStudentEnabled = state => state.showFullTimeStudent === ENABLED;
export const selectIfShowStateEmployeeHealthBenefitPlanEnabled = state => state.showStateEmployeeHealthBenefitPlan === ENABLED;
export const selectIfSogiFeatureEnabled = state => state.sogiFeature === ENABLED;
export const selectIfVoterRegistrationFeatureEnabled = state => state.voterRegistrationFeature === ENABLED;
export const selectIsInlineCurrentIncomeEnabled = state => state.inlineCurrentIncomeEnabled === ENABLED;
export const selectIsItfFeatureEnabled = state => state.itfFeature === ENABLED;
export const selectIsItuQuestionsDisabled = state => state.displayItuQuestions === DISABLED;
export const selectIsMemberRemovalReasonEnabled = state => state.collectMemberRemovalReason === ENABLED;
export const selectMedicaidEndDateOverride = state => state.medicaidEndDateOverride;
export const selectEndDateOfPregnancyOverride = state => state.endDateOfPregnancyOverride;
